import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Card1 from "../Images/NewsFeeds/Sensitization/20260225_102718.jpg";
import Card3 from "../Images/NewsFeeds/Sensitization/20260225_110721.jpg";
import Card4 from "../Images/NewsFeeds/Sensitization/20260225_134645.jpg";

function SensitizationValidationWorkshop() {
  return (
    <div className="art-page">
      <SEO
        title="Sensitization and Validation Workshop on National Standards for Institutional Cookstoves and Institutional Biogas Systems"
        description="CIRCODU, in partnership with MEMD and UNBS, is implementing the development of National Standards for Institutional Cookstoves and Institutional Biogas Systems."
        keywords="National standards, institutional cookstoves, institutional biogas systems, Uganda, CIRCODU, MEMD, UNBS, UECCC, sensitization, validation, workshop, stakeholders, clean cooking, sustainable development, standard development process, standard validation, clean cooking solutions, institutional cooking technologies, biogas systems standards Uganda, cookstove standards Uganda, clean cooking standards Uganda, stakeholder engagement Uganda, clean cooking workshop Uganda"
        url="/Sensitization-and-Validation-Workshop-on-National-Standards-for-Institutional-Cookstoves-and-Institutional-Biogas-Systems"
        image={Card4}
        datePublished="2026-02-25"
      />

      {/* ── Hero ──────────────────────────────────────── */}
      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Sensitization and Validation Workshop on National Standards for
              Institutional Cookstoves and Institutional Biogas Systems
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Article body ──────────────────────────────── */}
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              February 25, 2026
            </div>

            <h1 className="art-title">
              Sensitization and Validation Workshop on National Standards for
              Institutional Cookstoves and Institutional Biogas Systems
            </h1>
            <img
              src={Card1}
              alt="Stakeholders at the workshop"
              className="art-img"
            />
            <div className="texty">
              <p>
                National standards only deliver their full value when the people
                they affect have had a genuine opportunity to shape them. With
                that conviction at the centre of this process, the{" "}
                <strong>
                  Centre for Integrated Research and Community Development
                  Uganda (CIRCODU)
                </strong>
                , in partnership with the{" "}
                <strong>
                  Ministry of Energy and Mineral Development (MEMD)
                </strong>{" "}
                and the{" "}
                <strong>Uganda National Bureau of Standards (UNBS)</strong>,
                with support from the{" "}
                <strong>
                  Uganda Energy Credit Capitalisation Company (UECCC)
                </strong>
                , is implementing the development of National Standards for
                Institutional Cookstoves and Institutional Biogas Systems.
              </p>

              <h2 className="art-subheading">Purpose of the Initiative</h2>
              <p>
                This initiative is designed to serve two interconnected goals:
                to enable manufacturers to deliver higher-quality, safer, and
                more consistent cooking technologies — and to guide social
                institutions such as schools, hospitals, and prisons toward the
                adoption of clean, efficient, and sustainable cooking solutions
                that protect both people and the environment.
              </p>

              <h2 className="art-subheading">The Draft Standards</h2>
              <p>
                Through its Technical Committee on Mechanical Engineering
                (UNBS/TC 107), UNBS — through a structured partnership process —
                has developed the following two draft standards now under
                validation:
              </p>
              <ol>
                <li>
                  <strong>DUS 2688:2025</strong> – Biogas systems —
                  Institutional cooking and non-gasification
                </li>
                <li>
                  <strong>DUS 2689:2025</strong> – Clean cookstoves and clean
                  cooking solutions — Institutional biomass cookstove —
                  Specification
                </li>
              </ol>
              <img
                src={Card3}
                alt="Stakeholders at the workshop"
                className="art-img"
              />
              <h2 className="art-subheading">The Workshop</h2>
              <p>
                On <strong>Wednesday, 25th February 2026</strong>, CIRCODU and
                partners hosted a one-day{" "}
                <strong>Sensitization and Validation Workshop</strong> at{" "}
                <strong>
                  Protea Hotel by Marriott® Kampala Skyz Naguru, Kampala
                </strong>
                , bringing together key stakeholders to discuss and validate
                these draft standards. The workshop drew participation from:
              </p>
              <ol>
                <li>Industry representatives and manufacturers</li>
                <li>Testing laboratories</li>
                <li>Academic and research institutions</li>
                <li>Consumer and industry associations</li>
                <li>
                  Relevant Government Ministries, Departments and Agencies
                  (MDAs)
                </li>
                <li>Development partners</li>
              </ol>

              <h2 className="art-subheading">Outcomes and the Road Ahead</h2>
              <p>
                The engagement aimed to present the developed standards, gather
                stakeholder input, and validate key issues to ensure the final
                standards are comprehensive, practical, and genuinely responsive
                to Uganda's unique needs and cooking realities. Feedback
                gathered at this workshop feeds directly into the final drafting
                process before formal adoption.
              </p>
              <p>
                Together, we are strengthening clean cooking systems for
                sustainable development — one standard, one stakeholder, one
                step at a time.
              </p>
              <p>
                <em>For God and Our Country.</em>
              </p>
              <img
                src={Card4}
                alt="Stakeholders who participated in the workshop"
                className="art-img"
              />
            </div>

            <div className="art-cta">
              <p>
                For more information on the national standards development
                process or to get involved, contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>

            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SensitizationValidationWorkshop;
